import { Datagrid, DateField, List, ReferenceField, TextField, useRecordContext } from 'react-admin';
import { Show, SimpleShowLayout } from 'react-admin';
import { MarkdownField } from '../../components/MarkdownField';
import { default as icon } from '@mui/icons-material/Description';

export const show = () => (
    <Show>
        <SimpleShowLayout>
            <DateField source="date" />
            <DateField source="updatedAt" label="Last updated" showTime />
            <ReferenceField source="session_id" reference="sessions" />
			<TopicTitleField label="Topic" />
			<MarkdownField source="body" label="Summary" />
        </SimpleShowLayout>
    </Show>
);

const TopicTitleField = () => {
	const record = useRecordContext();
	//console.log( record );
	const field = `topic${record.topic_id}_title`;
	return (
		<ReferenceField source="session_id" reference="sessions">
			<TextField source={field} />
		</ReferenceField>
	);
}

export const list = () => {
	return (
		<List>
			<Datagrid>
				<DateField source="date" />
				<ReferenceField source="session_id" reference="sessions" />
				<TopicTitleField source="topic_id" />
			</Datagrid>
		</List>
	);
}

export const Summary = {
	list,
	show,
	icon
};